import * as actionTypes from '../actionTypes/editPower';

export function getLensPackages({ prodId, powerType, frameType }) {
    return { type: actionTypes.GET_LENS_PACKAGES, prodId, powerType, frameType, isEditPower: true };
}

export function getPowers({ productId, powerType }) {
    return { type: actionTypes.GET_POWERS, productId, powerType, isEditPower: true };
}
